module.exports = __webpack_public_path__ + "static/media/sequencing-dog-white.dc6b381f.svg";